/**
 * @module:  友盟统计
 * @author Liang Huang 
 * @date 2020-07-21 17:48:04 
 */

/**
  * 点击
  * @param category 表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。	
  * @param action 表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等。
  * @param label 用于更详细的描述事件，如具体是哪个视频，哪部小说。
  * @param value 用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格；请填写整数数值，如果填写为其他形式，系统将按0处理。若填写为浮点小数，系统会自动取整，去掉小数点。	
  * @param node 填写事件元素的div元素id。
  */
const click = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  node?: string,
) => {
  window._czc && window._czc.push([
    "_trackEvent",
    category,
    action,
    label,
    value,
    node,
  ]);
};

/**
 * 统计初始化
 * @param content_url 自定义虚拟PV页面的URL地址 	填写以斜杠‘/’开头的相对路径，系统会自动补全域名
 * @param referer_url 自定义该受访页面的来源页URL地址 	建议填写该异步加载页面的母页面。不填，则来路按母页面的来路计算。填为“空”，即""，则来路按“直接输入网址或书签”计算。
 */
const init = (content_url: string, referer_url?: string) => {
  window._czc && window._czc.push([
    '_trackPageview',
    content_url,
    referer_url
  ])
}
export default {
  click,
  init
};
